import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { EERIE, HEFFALUMP } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
const GuaranteeBannerInnerContentWrapper = styled(UIFlex).withConfig({
  displayName: "GuaranteeBannerInnerContent__GuaranteeBannerInnerContentWrapper",
  componentId: "sc-1dtocg1-0"
})(["padding-left:50px;padding-right:50px;min-width:0;"]);
const GuaranteeBannerContentHeader = styled(FormattedMessage).withConfig({
  displayName: "GuaranteeBannerInnerContent__GuaranteeBannerContentHeader",
  componentId: "sc-1dtocg1-1"
})(["font-size:20px;font-weight:600;color:", ";text-align:center;"], HEFFALUMP);
const GuaranteeBannerContentSubtext = styled(FormattedMessage).withConfig({
  displayName: "GuaranteeBannerInnerContent__GuaranteeBannerContentSubtext",
  componentId: "sc-1dtocg1-2"
})(["text-align:center;font-size:14px;font-weight:400;min-width:0;max-width:240px;"]);
export const GuaranteeBannerInnerContent = ({
  contentLabel,
  iconLabel
}) => {
  return /*#__PURE__*/_jsxs(GuaranteeBannerInnerContentWrapper, {
    align: "center",
    className: "m-all-5",
    direction: 'column',
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-bottom-2",
      color: EERIE,
      name: iconLabel,
      size: "medium"
    }), /*#__PURE__*/_jsx(GuaranteeBannerContentHeader, {
      message: `guaranteeBanner.${contentLabel}.header`
    }), /*#__PURE__*/_jsx(GuaranteeBannerContentSubtext, {
      className: "m-bottom-5",
      message: `guaranteeBanner.${contentLabel}.body`
    })]
  });
};